import _ from 'underscore';
import queryString from 'query-string';
import {
  createRequestContract,
  createResponseContract,

  requestVerbs,
  responseTypes,
  FetchPolicy,
} from '@bingads-webui-react/overreact';
import type { RequestFactoryContext } from '@bingads-webui-react/overreact';

import { schema } from '../../../environment/schema';
import { getDefaultOptions } from '../../../request-contract-helper/index';
import type {
  CouponWebsiteResult,
  CouponWebsiteVariables,
} from '../../../types';

function ccUrlFactory(params: RequestFactoryContext<CouponWebsiteVariables, null>) {
  const { variables } = params;

  const {
    locator,
    websiteUrl,
  } = variables;

  const { descriptor } = locator;
  const { uid, cid } = descriptor;

  const search = {
    cid,
    uid,
    websiteUrl,
  };

  const searchString = _.isEmpty(search) ? '' : `?${queryString.stringify(search)}`;

  return `cc/API/Coupon/GetCouponValidForCustomerWebsite${searchString}`;
}

function ccOptionsFactory() {
  return getDefaultOptions();
}

export const fetchRequestContract = createRequestContract<CouponWebsiteVariables, null>({
  schema,
  dataPath: 'user:customer:get_coupon_valid_for_customer_website',
  verb: requestVerbs.GET,
  fetchPolicy: FetchPolicy.NetworkOnly,
  uriFactoryFn: ccUrlFactory,

  headerFactoryFn: ccOptionsFactory,

  parentKeySelector: variables => variables.locator.descriptor.cid,
});

export const fetchResponseContract = createResponseContract<
  CouponWebsiteVariables,
  null,
  CouponWebsiteResult,
  CouponWebsiteResult[],
  CouponWebsiteResult[]
>({
  requestContract: fetchRequestContract,
  responseType: responseTypes.COLL,

  keySelector: result => result.websiteURL,
  processorFn: response => response,
});
